// extracted by css-extract-rspack-plugin
export default {"cardContainer":"as_tL","icon":"ByCAJ","responsive":"NkQCK","bigCard":"Ge0uE","cardVertical":"Grkc1","placeholder":"Uk_Bh","img":"pUGtV","blink":"yTcZW"};